import PropTypes from 'prop-types';
import EventCardMarketsSliderImpl from './event-card-markets-slider.js';
import MojitoCore from 'mojito/core';

/**
 * Markets slider shared by event cards. Renders the event market lines as a swipeable slider with
 * one pagination dot per market.
 *
 * @function EventCardMarketsSlider
 * @name view
 *
 * @memberof Mojito.Modules.EventCards.MarketsSlider
 */

/**
 * Event card markets slider prop types.
 *
 * @property {object} event - Event to show the markets of.
 * @property {string} [marketId] - Id of the promoted market. Shown as the first slide, followed by the event market lines. If omitted, only the event market lines are shown.
 * @property {boolean} [shouldRequestData = true] - Flag indicating whether the markets should be requested from content. If false, then markets will not be requested, hence in order to present info corresponding data should be already available in a store.
 * @property {boolean} [isCardHovered = false] - True when the parent card is hovered. Keeps the swiper navigation arrows visible while the pointer is over the card.
 *
 * @memberof Mojito.Modules.EventCards.MarketsSlider.view
 */
const propTypes = {
    event: PropTypes.object.isRequired,
    marketId: PropTypes.string,
    shouldRequestData: PropTypes.bool,
    isCardHovered: PropTypes.bool,
};

const defaultProps = {
    shouldRequestData: true,
    isCardHovered: false,
};

export default MojitoCore.Presentation.UIView(
    'EventCardMarketsSlider',
    EventCardMarketsSliderImpl,
    propTypes,
    defaultProps
);
